import { PrimeReactPTOptions } from "primereact/api";
import { MessagePassThroughMethodOptions } from "primereact/message";
import { classNames } from "primereact/utils";

export const message: PrimeReactPTOptions["message"] = {
  root: ({ props }: MessagePassThroughMethodOptions) => ({
    className: classNames(
      "inline-flex items-center justify-center align-top",
      "px-3 py-2 m-0 rounded-md border-0 text-sm",
      {
        "text-blue-700": props.severity == "info",
        "text-green-700": props.severity == "success",
        "text-orange-700": props.severity == "warn",
        "text-red-700": props.severity == "error",
      },
    ),
  }),
  icon: { className: "text-base mr-2" },
};
